import {
  TILES_ARE_LOADING,
  TILES_HAVE_BEEN_LOADED_WITH_ERROR,
  TILES_HAVE_LOADED,
  // CLEAR_TILES,
  TILE_TYPE_LIST_IS_LOADING,
  TILE_TYPE_LIST_IS_LOADED,
  TILE_TYPE_LIST_IS_LOADED_WITH_ERROR,
  TILES_SUCCESS_MESSAGE_RAISED,
  TILES_ERROR_MESSAGE_RAISED,
  TILES_RESTART_MESSAGES,
  TILES_OF_TYPE_LINKS_ARE_LOADING,
  TILES_OF_TYPE_LINKS_HAVE_BEEN_LOADED_WITH_ERROR,
  TILES_OF_TYPE_LINKS_HAVE_LOADED,
  GET_SINGLE_TILE_IS_LOADING,
  GET_SINGLE_TILE_IS_LOADED_WITH_ERROR,
  GET_SINGLE_TILE_IS_LOADED,
  GET_ADITIONAL_TILES,
  UPDATE_TILE_ARR,
} from "./actionTypes";

import {
  ADD_TILE,
  CHANGE_TILE_NAME,
  DELETE_TILE,
  ADD_LINK,
  REMOVE_LINK,
  UPDATE_LINK,
  GET_TILES,
  GET_TILE_TYPES,
  ADD_DOCUMENT,
  UPDATE_TILE_POST,
  // UPDATE_TILE,
} from "../constants/urls";

import axios from "axios";
import { getDocument } from "./filterActions";
import { TILE_TYPE_GROUP_OF_TILES } from "../constants/stringConstants";

export function addDocument(
  userToken,
  topic_id,
  document_name,
  reference_id,
  tile_name,
  tile_type,
  tile_audience
) {
  return (dispatch) => {
    axios({
      url: ADD_DOCUMENT,
      params: {
        usertoken: userToken,
        topic_id,
        document_name,
        reference_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        dispatch(getDocument(userToken, reference_id, topic_id));
        dispatch(
          addTile(
            userToken,
            tile_name,
            tile_type,
            tile_audience,
            response.data.document_id
          )
        );
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function getTiles(
  usertoken,
  topic_document_id,
  tile_id,
  no_tile_details
  /*, tile_type*/
) {
  return (dispatch) => {
    dispatch(tilesAreLoading(true));
    if (
      (topic_document_id && !isNaN(topic_document_id)) ||
      (tile_id && !isNaN(tile_id))
    ) {
      axios({
        url: GET_TILES,
        params: {
          usertoken,
          topic_document_id,
          tile_id,
          no_tile_details,
          //tile_type,
        },
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "aplication/json",
        },
      })
        .then((response) => {
          dispatch(tilesAreLoaded(response.data.RegHub_response));
        })
        .catch((err) => {
          dispatch(tilesAreLoadedWithError());
          dispatch(
            tilesErrorMessageRaised(err.response ? err.response.data : err)
          );
        });
    }
  };
}

// export function getTiles(
//   userToken,
//   topic_document_id,
//   tileId,
//   noTileDetails
//   /*, tileType*/
// ) {
//   return (dispatch) => {
//     dispatch(tilesAreLoading(true));

//     // Check if required parameters are present
//     if (
//       (topic_document_id && !isNaN(topic_document_id)) ||
//       (tileId && !isNaN(tileId))
//     ) {
//       axios({
//         url: GET_TILES,
//         params: {
//           userToken,
//           topic_document_id,
//           tileId,
//           noTileDetails,
//           // tileType,
//         },
//         method: "GET",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//       })
//         .then((response) => {
//           dispatch(tilesAreLoaded(response.data.RegHub_response));
//         })
//         .catch((err) => {
//           console.error("Error fetching tiles:", err);
//           dispatch(tilesAreLoadedWithError());
//           dispatch(
//             tilesErrorMessageRaised(err.response ? err.response.data : err)
//           );
//         });
//     } else {
//       console.warn("Invalid parameters for fetching tiles");
//       dispatch(tilesAreLoadedWithError());
//     }
//   };
// }

export function tilesAreLoading() {
  return {
    type: TILES_ARE_LOADING,
  };
}

export function tilesAreLoadedWithError() {
  return {
    type: TILES_HAVE_BEEN_LOADED_WITH_ERROR,
  };
}

export function tilesAreLoaded(tiles) {
  return {
    type: TILES_HAVE_LOADED,
    tiles,
  };
}

// export function tilesAreCleared() {
//   return {
//     type: CLEAR_TILES,
//     tiles: [],
//     dataTiles: [],
//   };
// }

export function getSingleTile(usertoken, tile_id) {
  return (dispatch) => {
    dispatch(singleTileIsLoading(true));
    if (tile_id) {
      axios({
        url: GET_TILES,
        params: {
          usertoken,
          topic_document_id: "",
          tile_id,
          tile_type: TILE_TYPE_GROUP_OF_TILES,
        },
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "aplication/json",
        },
      })
        .then((response) => {
          dispatch(singleTileIsLoaded(response.data.RegHub_response[0]));
        })
        .catch((err) => {
          dispatch(singleTileIsLoadedWithError());
          dispatch(
            tilesErrorMessageRaised(err.response ? err.response.data : err)
          );
        });
    }
  };
}

export function singleTileIsLoading() {
  return {
    type: GET_SINGLE_TILE_IS_LOADING,
  };
}

export function singleTileIsLoadedWithError() {
  return {
    type: GET_SINGLE_TILE_IS_LOADED_WITH_ERROR,
  };
}

export function singleTileIsLoaded(singleTile) {
  return {
    type: GET_SINGLE_TILE_IS_LOADED,
    singleTile,
  };
}
export function additionalTiles(additionalTiles) {
  return {
    type: GET_ADITIONAL_TILES,
    additionalTiles,
  };
}

export const updateDataArr = (data) => {
  return {
    type: UPDATE_TILE_ARR,
    payload: data,
  };
};
export function getTilesOfTypeLinks(
  usertoken,
  topic_document_id,
  no_tile_details
) {
  return (dispatch) => {
    dispatch(tilesOfTypeLinksAreLoading(true));
    axios({
      url: GET_TILES,
      params: {
        usertoken,
        tile_type: "Links",
        // topic_document_id: "",
        topic_document_id,
        no_tile_details,
        tile_id: "",
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(tilesOfTypeLinksAreLoaded(response.data.RegHub_response));
      })
      .catch((err) => {
        dispatch(tilesOfTypeLinksAreLoadedWithError());
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function tilesOfTypeLinksAreLoading() {
  return {
    type: TILES_OF_TYPE_LINKS_ARE_LOADING,
  };
}

export function tilesOfTypeLinksAreLoadedWithError() {
  return {
    type: TILES_OF_TYPE_LINKS_HAVE_BEEN_LOADED_WITH_ERROR,
  };
}

export function tilesOfTypeLinksAreLoaded(tilesOfTypeLinks) {
  return {
    type: TILES_OF_TYPE_LINKS_HAVE_LOADED,
    tilesOfTypeLinks,
  };
}

export function tilesSuccessMessageRaised(tileSuccessMessage) {
  return {
    type: TILES_SUCCESS_MESSAGE_RAISED,
    tileSuccessMessage,
  };
}

export function tilesErrorMessageRaised(tileErrorMessage) {
  return {
    type: TILES_ERROR_MESSAGE_RAISED,
    tileErrorMessage,
  };
}

export function tilesRestartMessages() {
  return {
    type: TILES_RESTART_MESSAGES,
  };
}

export function getTileTypes(usertoken) {
  return (dispatch) => {
    dispatch(tilesAreLoading(true));
    axios({
      url: GET_TILE_TYPES,
      params: {
        usertoken,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        let tileTypes = [];

        Object.keys(response.data).forEach((tileType) => {
          tileTypes.push(response.data[tileType]);
        });

        dispatch(tileTypeListIsLoaded(tileTypes));
      })
      .catch((err) => {
        dispatch(tileTypeListIsLoadedWithError());
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function tileTypeListIsLoading() {
  return {
    type: TILE_TYPE_LIST_IS_LOADING,
  };
}

export function tileTypeListIsLoadedWithError() {
  return {
    type: TILE_TYPE_LIST_IS_LOADED_WITH_ERROR,
  };
}

export function tileTypeListIsLoaded(tileTypes) {
  return {
    type: TILE_TYPE_LIST_IS_LOADED,
    tileTypes,
  };
}
export function getTilesAdditional(
  usertoken,
  topic_document_id,
  tile_id,
  no_tile_details
  /*, tile_type*/
) {
  return (dispatch) => {
    // dispatch(tilesAreLoading(true));
    if (
      (topic_document_id && !isNaN(topic_document_id)) ||
      (tile_id && !isNaN(tile_id))
    ) {
      axios({
        url: GET_TILES,
        params: {
          usertoken,
          topic_document_id,
          tile_id,
          no_tile_details,
          //tile_type,
        },
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "aplication/json",
        },
      })
        .then((response) => {
          dispatch(additionalTiles(response.data.RegHub_response));
          dispatch(updateDataArr(response.data.RegHub_response));
        })
        .catch((err) => {
          dispatch(tilesAreLoadedWithError());
          dispatch(
            tilesErrorMessageRaised(err.response ? err.response.data : err)
          );
        });
    }
  };
}
export function addTile(
  usertoken,
  tile_name,
  tile_type,
  tile_audience,
  topic_document_id
  //tile_types
) {
  return (dispatch) => {
    axios({
      url: ADD_TILE,
      params: {
        usertoken,
        tile_name,
        tile_type,
        tile_audience,
        topic_document_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(
          getTilesAdditional(
            usertoken,
            topic_document_id,
            undefined /*, tile_types*/
          )
        );
        dispatch(
          getTiles(usertoken, topic_document_id, undefined /*, tile_types*/)
        );
        dispatch(tilesSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

// export function updateTile(
//   usertoken,
//   tile_id,
//   tile_name,
//   tile_value,
//   tile_audience,
//   tile_type,
//   topic_id,
//   tile_types
// ) {
//   return (dispatch) => {
//     axios({
//       url: UPDATE_TILE,
//       params: {
//         usertoken,
//         tile_id,
//         tile_name,
//         tile_value,
//         tile_audience,
//         tile_type,
//         topic_id,
//       },
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "aplication/json",
//       },
//     })
//       .then((response) => {
//         if (topic_id || tile_types) {
//           dispatch(
//             getTilesAdditional(
//               usertoken,
//               topic_id,
//               tile_types ? "" : undefined /*, tile_types*/
//             )
//           );
//           dispatch(
//             getTiles(
//               usertoken,
//               topic_id,
//               tile_types ? "" : undefined /*, tile_types*/
//             )
//           );
//         } else {
//           dispatch(
//             getTilesAdditional(usertoken, undefined, tile_id /*, tile_types*/)
//           );
//           dispatch(getTiles(usertoken, undefined, tile_id /*, tile_types*/));
//         }
//         dispatch(tilesSuccessMessageRaised(response.data));
//       })
//       .catch((err) => {
//         dispatch(
//           tilesErrorMessageRaised(err.response ? err.response.data : err)
//         );
//       });
//   };
// }

export function updateTile({
  usertoken,
  tile_id,
  tile_name,
  tile_value,
  tile_audience,
  tile_type,
  topic_id,
  tile_types,
}) {
  return (dispatch) => {
    const formData = new FormData();
    formData.append("usertoken", usertoken);
    formData.append("tile_id", tile_id);
    formData.append("tile_name", tile_name);
    // formData.append("tile_value", tile_value);
    formData.append("tile_value", JSON.stringify(tile_value));
    formData.append("tile_audience", tile_audience);
    formData.append("tile_type", tile_type);
    formData.append("topic_id", topic_id);

    const asString = new URLSearchParams(formData).toString();

    axios({
      url: UPDATE_TILE_POST,
      method: "POST",
      data: asString,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        if (topic_id || tile_types) {
          dispatch(
            getTilesAdditional(
              usertoken,
              topic_id,
              tile_types ? "" : undefined /*, tile_types*/
            )
          );
          dispatch(
            getTiles(
              usertoken,
              topic_id,
              tile_types ? "" : undefined /*, tile_types*/
            )
          );
        } else {
          dispatch(
            getTilesAdditional(usertoken, undefined, tile_id /*, tile_types*/)
          );
          dispatch(getTiles(usertoken, undefined, tile_id /*, tile_types*/));
        }
        dispatch(tilesSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function changeTileName(usertoken, tile_id, tile_name, topic_id) {
  return (dispatch) => {
    axios({
      url: CHANGE_TILE_NAME,
      params: {
        usertoken,
        tile_id,
        tile_name,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        if (topic_id) {
          dispatch(getTiles(usertoken, topic_id, undefined));
        } else {
          dispatch(getTiles(usertoken, undefined, tile_id));
        }
        dispatch(tilesSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function deleteTile(usertoken, tile_id, topic_id, tile_types) {
  return (dispatch) => {
    axios({
      url: DELETE_TILE,
      params: {
        usertoken,
        tile_id,
        topic_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        if (topic_id || tile_types) {
          dispatch(
            getTilesAdditional(
              usertoken,
              topic_id,
              tile_types ? "" : undefined /*, tile_types*/
            )
          );
          dispatch(
            getTiles(
              usertoken,
              topic_id,
              tile_types ? "" : undefined /*, tile_types*/
            )
          );
        } else {
          dispatch(
            getTilesAdditional(usertoken, undefined, tile_id /*, tile_types*/)
          );
          dispatch(getTiles(usertoken, undefined, tile_id /*, tile_types*/));
        }
        dispatch(tilesSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function addLink(
  usertoken,
  tile_id,
  link_name,
  link_url,
  link_description,
  topic_id,
  fromDocumentPage,
  tile_types
) {
  return (dispatch) => {
    axios({
      url: ADD_LINK,
      params: {
        usertoken,
        tile_id,
        link_name,
        link_url,
        link_description,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        if (!fromDocumentPage) {
          if (topic_id || tile_types) {
            dispatch(
              getTiles(usertoken, topic_id, tile_types ? "" : undefined)
            );
          } else {
            dispatch(getTiles(usertoken, undefined, tile_id));
          }
        }

        dispatch(tilesSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function removeLink(usertoken, link_id, tile_id, topic_id, tile_types) {
  return (dispatch) => {
    axios({
      url: REMOVE_LINK,
      params: {
        usertoken,
        link_id,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        if (topic_id || tile_types) {
          dispatch(getTiles(usertoken, topic_id, tile_types ? "" : undefined));
        } else {
          dispatch(getTiles(usertoken, undefined, tile_id));
        }
        dispatch(tilesSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function updateLink(
  usertoken,
  tile_id,
  link_id,
  link_name,
  link_url,
  link_description,
  topic_id,
  tile_types
) {
  return (dispatch) => {
    axios({
      url: UPDATE_LINK,
      params: {
        usertoken,
        tile_id,
        link_id,
        link_name,
        link_url,
        link_description,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        if (topic_id || tile_types) {
          dispatch(getTiles(usertoken, topic_id, tile_types ? "" : undefined));
        } else {
          dispatch(getTiles(usertoken, undefined, tile_id));
        }
        dispatch(tilesSuccessMessageRaised(response.data));
      })
      .catch((err) => {
        dispatch(
          tilesErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}

export function getTilesForSavingResult(
  usertoken,
  tile_name,
  topic_document_id
) {
  return (dispatch) => {
    dispatch(tilesAreLoading(true));
    if (topic_document_id && !isNaN(topic_document_id)) {
      axios({
        url: GET_TILES,
        params: {
          usertoken,
          tile_name,
          topic_document_id,
        },
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "aplication/json",
        },
      })
        .then((response) => {
          dispatch(tilesAreLoaded(response.data.RegHub_response));
        })
        .catch((err) => {
          dispatch(tilesAreLoadedWithError());
          dispatch(
            tilesErrorMessageRaised(err.response ? err.response.data : err)
          );
        });
    }
  };
}
